import facebook from './facebook.png';
import instagram from './instagram.png';
import './styles.css';

export const Map = () => (
  <footer className="site-footer">
    <div className="footer-map-wrap">
      <iframe
        title="Rue's Events Designs location"
        src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=6%20trent%20road,%20harare,%20zimbabwe+(Rue's%20Events%20Designs)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>

    <div className="footer-main">
      <div className="section-shell footer-grid">
        <div className="footer-about">
          <p className="footer-eyebrow">Ruesevents Designs</p>
          <h2>Creating memorable moments across Zimbabwe.</h2>
          <p>
            Event décor, florals, event management and hiring services designed with creativity,
            care and attention to detail.
          </p>
        </div>

        <div className="footer-contact">
          <h3>Get in touch</h3>
          <a href="tel:+263784532559">+263 784 532 559</a>
          <a href="tel:+263775967763">+263 775 967 763</a>
          <a href="tel:+263716311137">+263 716 311 137</a>
          <a href="mailto:info@ruesevents.co.zw">info@ruesevents.co.zw</a>
          <span>6 Trent Road, Harare, Zimbabwe</span>
        </div>

        <div className="footer-follow">
          <h3>Follow us</h3>
          <div className="footer-socials">
            <a href="https://www.facebook.com/Rueseventsdesigns1" target="_blank" rel="noreferrer" aria-label="Facebook">
              <img src={facebook} alt="" />
            </a>
            <a href="https://www.instagram.com/rueseventsdesigns/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <img src={instagram} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="copyright" className="footer-bottom">
      <div className="section-shell footer-bottom-inner">
        <span>© {new Date().getFullYear()} Ruesevents Designs. All rights reserved.</span>
        
      </div>
    </div>
  </footer>
);
